import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-cream" data-id="element-56" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-57" data-mp="83m7bpl77gwv">
        <p className="inline-block rounded border-2 border-brand-gold bg-brand-choco px-2 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white" data-id="element-58" data-mp="m46s2raobmt0">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-brand-choco/80" data-id="element-59" data-mp="vu8dtcfk0t4r">
          Podés seguir guardando recetas de tortas, brownies, alfajores y postres
          sin saber qué deberías aprender primero. O podés comenzar hoy a
          construir una nueva habilidad siguiendo una ruta organizada desde cero.
        </p>
        <h2 id="cierre" className="mt-1.5 font-display text-base font-extrabold leading-tight text-brand-choco sm:text-xl" data-id="element-60" data-mp="2c4oc0yv5lb79">
          No necesitás ser experto en pastelería para empezar.{' '}
          <span className="text-brand-pink" data-id="element-61" data-mp="2m2kuycuc1afx">Necesitás dar el primer paso.</span>
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-dashed border-brand-pink bg-white p-3 text-brand-choco" data-id="element-62" data-mp="2r2gotj9bflhr">
          <p className="font-display text-[0.8rem] font-black uppercase leading-tight text-brand-pink sm:text-sm" data-id="element-63" data-mp="2v2hdrxu1jf32">
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 inline-block rounded border-2 border-brand-gold bg-brand-choco px-2.5 py-0.5 font-display text-sm font-black uppercase tracking-wide text-white" data-id="element-64" data-mp="300978wac399d">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-[0.75rem] text-brand-choco/80" data-id="element-65" data-mp="3errosyiudbuu">
            Valor de los bonos:{' '}
            <span className="text-brand-pinkdark line-through" data-id="element-66" data-mp="3islhs6b55gul">{BONUS_VALUE}</span>
          </p>
          <p className="mt-1 font-display text-5xl font-black leading-none tracking-tight text-brand-pink sm:text-6xl" data-id="element-67" data-mp="1jntqzs9obvxa">
            Hoy: {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-68" data-mp="1en5qmfzk22qe">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-brand-choco/80" data-id="element-69" data-mp="1nq6vkdcopnsh">
            <span className="flex items-center gap-1" data-id="element-70" data-mp="22djjg8pys5m1">
              <ZapIcon size={12} className="text-brand-pink" data-id="element-71" data-mp="1xg06rd8x00w7" />
              Acceso Inmediato
            </span>
            <span className="text-brand-choco/40" data-id="element-72" data-mp="2bg162o9j709k">•</span>
            <span data-id="element-73" data-mp="2bdezorydmqsx">Entrega Digital</span>
            <span className="text-brand-choco/40" data-id="element-74" data-mp="27dedgl51dbbb">•</span>
            <span className="flex items-center gap-1" data-id="element-75" data-mp="27btf0kflp886">
              <ShieldCheckIcon size={12} className="text-brand-gold" data-id="element-76" data-mp="h2jgkvpkftbw" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}